import { Link } from "react-router-dom";
import ReactTimeAgo from "react-time-ago";


export default function Revendeur({user, position}) {
    // states


    // comportements


    // Affichage
    return (
        <tr style={{borderStyle: "none"}}>
            <td className="text-center">{position + 1}</td>
            <td>
                <div className="d-flex flex-row">
                    <div className="widget-content-left mr-3">
                        <img style={{width: 48, height: 48}} className="rounded" src={user.photo !== null ? user?.photo : "/assets/imgs/blank.png"} alt="" />
                    </div>
                    <div className="widget-content-left">
                        <div className="widget-heading">{user?.nom} {user?.prenom}</div>
                        <div className="widget-subheading">{user?.email}</div>
                    </div>
                </div>
            </td>
            <td>{user?.numtel}</td>
            <td>{user?.solde} XAF</td>
            <td>{user?.retenu} %</td>
            <td>{user?.datecrea ? <ReactTimeAgo date={Date.parse(user?.datecrea)} timeStyle="facebook" /> : ""}</td>
            <td className="text-center">
                <Link to={`/revendeur/${user?.code}`} data-toggle="tooltip" title="View user" data-placement="left" className="btn-shadow-primary mr-2 ml-2 btn btn-sm btn-primary">
                    <i className="fa fa-eye"></i>
                </Link>
            </td>
        </tr>
    )
}